import { Component, NgZone, OnInit, Inject } from '@angular/core';
import mdcAutoInit from '@material/auto-init';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { MDCCheckbox } from '@material/checkbox/component';
import { AuthService } from '../services/auth.service';
import { Roles } from '../models/Roles';
import { User } from '../models/User';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { MDCRadio } from '@material/radio';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-createuser',
  templateUrl: './createuser.component.html',
  styleUrls: ['./createuser.component.css']
})
export class CreateuserComponent implements OnInit {
  name: string;
  specialty: string;
  topic: string;
  email: string;
  password: string;
  checkboxAdmin: any;
  checkboxConsultant: any;
  errorMessage: string;
  curentUser: firebase.User;
  userType: String;
  showCreateAdmin: boolean;
  constructor(public auths: AuthService, public router: Router, public ng: NgZone, public dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateuserComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.name = '';
    this.topic = '';
    this.specialty = '';
    this.email = '';
    this.password = '';
    this.errorMessage = '';
    this.userType = 'a User';
    this.showCreateAdmin = false;
  }

  ngOnInit() {
    this.auths.user.subscribe((user) => {
      if (user !== null && user !== undefined) {
        this.curentUser = user;
        const db = firebase.firestore();
        document.getElementById('nuageMenu').style.display = 'block';
        db.collection('users').where('uid', '==', user.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data()['role'] === Roles.consultant) {
              this.ng.run(() => this.router.navigateByUrl('/'));
            } else if (doc.data().role !== Roles.clientAdmin && doc.data().role !== Roles.superUser) {
              this.showCreateAdmin = true;
              this.onCheckedAccount('a User');
            } else if (doc.data().role === Roles.clientAdmin || doc.data().role === Roles.superUser) {
              this.onCheckedAccount('a Consultant');
            }
          });
        });
      } else if (user === undefined && user === null) {
        document.getElementById('nuageMenu').style.display = 'none';
        this.router.navigateByUrl('/');
      }
    });
    const nameSignup = new MDCTextField(document.querySelector('.name-signup'));
    const emailSignup = new MDCTextField(document.querySelector('.email-signup'));
    const passwordSignup = new MDCTextField(document.querySelector('.password-signup'));
    const consultantRadio = new MDCRadio(document.querySelector('.cons-radio'));
    const adminRadio = new MDCRadio(document.querySelector('.admin-radio'));
    this.checkboxAdmin = document.getElementById('radio-admin');

    this.checkboxConsultant = document.getElementById('radio-consultant');
    const selector = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
    const ripples = [].map.call(document.querySelectorAll(selector), function (el) {
      return new MDCRipple(el);
    });
    this.auths.errorAuth.subscribe((error) => {
      this.errorMessage = error;
    });
  }

  createUser() {
    if (this.email === '' || this.name === '' || this.password === '') {
      this.errorMessage = 'Please fill in all fields';
    } else {
      if (this.data.userType === 'Admin') {
        const user = new User(Roles.clientAdmin, this.email, this.name, '');
        this.auths.createUserAndSendPasswordResetEmail(this.password, user, this.curentUser.uid);
      } else if (this.data.userType === 'consultant') {
        const user = new User(Roles.consultant, this.email, this.name, '');
        this.auths.createUserAndSendPasswordResetEmail(this.password, user, this.curentUser.uid);
      } else {
        this.errorMessage = 'Made it this far';
      }
    }
  }

  onCheckedAccount(type: String) {
    this.userType = type;
  }

  goBack() {
    window.history.back();
  }
}
